<template>
  <div id="app">
    <!-- <div style="display: block"> -->
    <div style="display: none">
    <h3 v-if="user != null">
      You are Logged In By Phone No - {{user.phoneNumber}}
      <button @click="signout()">signout</button>
    </h3>
    <h3 v-else>You are Not Logged In ! <br>
      <router-link to="/">Login</router-link>
      <router-link to="/signup">Signup</router-link>
    </h3>
    </div>
    <router-view/>
  </div>
</template>

<script>
  import firebase from 'firebase'

  import './assets/moijoy.webflow.css';


  export default {
    name: 'app',
    props:['user'],
    methods:{
      signout(){
        firebase.auth().signOut();
        this.$router.push({path:'/sign-up'})
        window.location.reload(); //reload on signout !
      },
    }
  }
</script>

<style>

  #app {
    

  }

  
</style>



// WEBPACK FOOTER //
// src/App.vue